/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

export type BTAdminBuilderPreference =
  (typeof BTAdminBuilderPreference)[keyof typeof BTAdminBuilderPreference];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BTAdminBuilderPreference = {
  notificationHistoryRedesign: "notificationHistoryRedesign",
  taskManagementOptIn: "taskManagementOptIn",
  selectionOptionDocumentScraping: "selectionOptionDocumentScraping",
  jcbViewDropdown: "jcbViewDropdown",
  subsAuth0Migration: "subsAuth0Migration",
  permissionsMfaEnrollmentCohort: "permissionsMfaEnrollmentCohort",
  rFIOwnersV1: "rFIOwnersV1",
  bdsContentHeaderListPageReplacement: "bdsContentHeaderListPageReplacement",
  worksheetAGGrid: "worksheetAGGrid",
  estimateMobileServices: "estimateMobileServices",
  sageARPayments: "sageARPayments",
  sageSync: "sageSync",
  paymentMethodUI: "paymentMethodUI",
  paymentsSetupTab: "paymentsSetupTab",
  tasksGeneralJob: "tasksGeneralJob",
  billsFullPageConversion: "billsFullPageConversion",
  changeOrdersNewItemHeader: "changeOrdersNewItemHeader",
  bdsContentHeaderIndividualReplacements:
    "bdsContentHeaderIndividualReplacements",
  budgetCostCodeCaching: "budgetCostCodeCaching",
  bulkExport: "bulkExport",
  sageIntacctMVP: "sageIntacctMVP",
  taskDependencies: "taskDependencies",
  scanAllBillAttachments: "scanAllBillAttachments",
  editBillPercentage: "editBillPercentage",
  inFlightWorkflowEdits: "inFlightWorkflowEdits",
  timeClockLegacyGeneralJobCleanup: "timeClockLegacyGeneralJobCleanup",
  markupCostCodeRollup: "markupCostCodeRollup",
  lienWaiversMassPay: "lienWaiversMassPay",
  billLineItemContainer: "billLineItemContainer",
  useNotificationsEmail: "useNotificationsEmail",
  selfServiceMfaManagement: "selfServiceMfaManagement",
  mobileOwnerInvoiceLineItems: "mobileOwnerInvoiceLineItems",
  changeOrderGroupSubgroups: "changeOrderGroupSubgroups",
  plansViewerReducedTileSize: "plansViewerReducedTileSize",
  taskGantt: "taskGantt",
  scopeOfWorkMobileCardView: "scopeOfWorkMobileCardView",
  bdsContentHeaderModalReplacement: "bdsContentHeaderModalReplacement",
  tasksCustomFieldSortTweaks: "tasksCustomFieldSortTweaks",
  allocateBillCostsAcrossMultipleJobs: "allocateBillCostsAcrossMultipleJobs",
  rfiBluebeam: "rfiBluebeam",
  customForwardEmailAlias: "customForwardEmailAlias",
  partialPaymentLienWaivers: "partialPaymentLienWaivers",
  selectionsReimagined: "selectionsReimagined",
  aIASignatureWorkflow: "aIASignatureWorkflow",
  sageInvoice: "sageInvoice",
  timeClockShiftDetailsHistory: "timeClockShiftDetailsHistory",
  progressInvoiceRevisedBudgetColumn: "progressInvoiceRevisedBudgetColumn",
  xeroReconnectAfterError: "xeroReconnectAfterError",
  aiaPurchaseOrder: "aiaPurchaseOrder",
  financialEntityNumbering: "financialEntityNumbering",
  disableToDos: "disableToDos",
  useRemoteEmailClassification: "useRemoteEmailClassification",
  billLineItemContainerDesktop: "billLineItemContainerDesktop",
  lowesInCompanySettings: "lowesInCompanySettings",
  infoArchOptIn: "infoArchOptIn",
  vendorCreditOCRDetection: "vendorCreditOCRDetection",
  deferBillsPermissionCalls: "deferBillsPermissionCalls",
  trackAllowanceProgress: "trackAllowanceProgress",
  mobileInAppFeedback: "mobileInAppFeedback",
  watchingForTasks: "watchingForTasks",
  billAccountingSyncMoment: "billAccountingSyncMoment",
  invoiceCreationAlignment: "invoiceCreationAlignment",
  improvedSubLienWaivers: "improvedSubLienWaivers",
  requireStepUpAuthForOutboundPayments: "requireStepUpAuthForOutboundPayments",
  tasksCalendarFeed: "tasksCalendarFeed",
  schedulePagedGanttPrint: "schedulePagedGanttPrint",
  selectionsAICostCodeMatching: "selectionsAICostCodeMatching",
  autoFillInvoice: "autoFillInvoice",
  progressInvoiceRetainageIndicator: "progressInvoiceRetainageIndicator",
  taxesChangeOrders: "taxesChangeOrders",
  estimateActivityLog: "estimateActivityLog",
  billPaymentScheduling: "billPaymentScheduling",
  unconditionalLienWaivers: "unconditionalLienWaivers",
  bulkRoleManagement: "bulkRoleManagement",
  apBillRetainage: "apBillRetainage",
  mobileWebviewExperience: "mobileWebviewExperience",
  paymentsControllerRefactor: "paymentsControllerRefactor",
  bluebeamIntegration: "bluebeamIntegration",
  multiInvoicePdfSplitDetectionReview: "multiInvoicePdfSplitDetectionReview",
  multipleLienWaiversOnBills: "multipleLienWaiversOnBills",
  enableNutrientPhotoDraw: "enableNutrientPhotoDraw",
  nutrientLienWaiverSigning: "nutrientLienWaiverSigning",
  sharePaymentScheduleOnAllFixedPriceJobs:
    "sharePaymentScheduleOnAllFixedPriceJobs",
  newItemHeaderDefaultJobPermissions: "newItemHeaderDefaultJobPermissions",
  paymentScheduleAfterSendToBudget: "paymentScheduleAfterSendToBudget",
  costInboxMigration: "costInboxMigration",
  disableSubOwnerExternalEmails: "disableSubOwnerExternalEmails",
  invoiceHideLaborCostsDefault: "invoiceHideLaborCostsDefault",
  selectionsInvoicingWizard: "selectionsInvoicingWizard",
  taskPhaseDemo: "taskPhaseDemo",
  qbdWebConnectorHangfireDefer: "qbdWebConnectorHangfireDefer",
  globalSpecCatalog: "globalSpecCatalog",
  billsAgGridMigration: "billsAgGridMigration",
  aIPreliminaryEstimate: "aIPreliminaryEstimate",
  selectionOptionsLineItemCard: "selectionOptionsLineItemCard",
  specPublishPushNotifications: "specPublishPushNotifications",
  enableSpecPublishNotifications: "enableSpecPublishNotifications",
  genericLinkingSpecsToCO: "genericLinkingSpecsToCO",
  specsCarryForwardToBidPackage: "specsCarryForwardToBidPackage",
  linkPlansToSubmittals: "linkPlansToSubmittals",
  quickBooksMigrationInvoices: "quickBooksMigrationInvoices",
  plansMultiDocRevisions: "plansMultiDocRevisions",
  messagesAllowMobileVideoUploads: "messagesAllowMobileVideoUploads",
  jpsFinancialOverviewRevamp: "jpsFinancialOverviewRevamp",
  billsAccountingExport: "billsAccountingExport",
  taskAssistantOptIn: "taskAssistantOptIn",
  selectionsInvoicingWizardLineItems: "selectionsInvoicingWizardLineItems",
  estimateWorksheetPanelView: "estimateWorksheetPanelView",
  taxesSelectionChoices: "taxesSelectionChoices",
  globalSpecCostGroupLinking: "globalSpecCostGroupLinking",
  dailyLogsAutoSave: "dailyLogsAutoSave",
  plansAiVersionSummary: "plansAiVersionSummary",
  splitBillsPOsBudgetSettings: "splitBillsPOsBudgetSettings",
  mobileDirectoryAddExperience: "mobileDirectoryAddExperience",
  defaultSpcOn: "defaultSpcOn",
  aiPoweredSearch: "aiPoweredSearch",
  jcbFind: "jcbFind",
  billsMobileConversion: "billsMobileConversion",
  defaultMarkAsBillableInQB: "defaultMarkAsBillableInQB",
  templateSupportForSelectionOptions: "templateSupportForSelectionOptions",
  expenseAccountingSync: "expenseAccountingSync",
  warrantiesModalConversion: "warrantiesModalConversion",
} as const;
